import {FormControl, IInputProps, Input} from 'native-base';
import React from 'react';
import {Control, Controller} from 'react-hook-form';
import {View} from 'react-native';
import Text from './Text';
import formatPhoneNumber from '../utils/phoneNumberFormatter';
import shouldAutoFocus from '../utils/shouldAutoFocus';

interface I_TextInput_Props {
  control: Control;
  name: string;
  label: string;
  placeholder?: string;
  labelStyle?: Partial<IInputProps>;
}

export default function TextInput(props: I_TextInput_Props & IInputProps) {
  const {
    control,
    name,
    label,
    labelStyle = {},
    placeholder = '',
    autoFocus,
    ...otherProps
  } = props;
  const resolvedAutoFocus = shouldAutoFocus(autoFocus);

  return (
    <View style={{marginVertical: 0, flex: 1}}>
      <Controller
        control={control}
        render={({
          field: {onChange, onBlur, value},
          fieldState: {isTouched, invalid, error},
        }) => {
          return (
            <FormControl isInvalid={isTouched && invalid}>
              <FormControl.Label _text={labelStyle} fontStyle={400}>
                {label}
              </FormControl.Label>
              <Input
                placeholder={placeholder}
                style={{marginTop: 8, fontSize: 18}}
                onChangeText={text =>
                  name == 'phone1'
                    ? onChange(formatPhoneNumber(text))
                    : onChange(text)
                }
                onBlur={onBlur}
                value={name == 'phone1' ? formatPhoneNumber(value) : value}
                autoFocus={resolvedAutoFocus}
                {...otherProps}
                _stack={{style: {}}}
              />
              <Text style={{marginVertical: 8, color: 'red'}}>
                {error?.message}
              </Text>
            </FormControl>
          );
        }}
        name={name}
      />
    </View>
  );
}
